import ExampleMap from '../components/ExampleMap';
//, { homeBlockHeight }

const HomeView = () => {
    return <ExampleMap />;
};

export default HomeView;
